import {
  materializeNextStep,
  materializeQuizProgress,
  materializeSurveyProgress,
} from 'src/v3/classroom-v2/utils/api'
import { CourseProgressSummary, CourseProgressSummaryWire } from '../types'

// Reuses classroom-v2's materializers for quiz/survey/nextStep — same wire
// vocabulary, so one parser rather than a second copy that could drift.
export let materializeCourseProgress = (
  wire: CourseProgressSummaryWire,
): CourseProgressSummary => ({
  courseID: wire.courseID,
  version: wire.version,
  totalSteps: wire.totalSteps,
  completedSteps: wire.completedSteps,
  state: wire.state,
  certificate: wire.certificate,
  quiz: wire.quiz == null ? null : materializeQuizProgress(wire.quiz),
  survey: wire.survey == null ? null : materializeSurveyProgress(wire.survey),
  nextStep: materializeNextStep(wire.nextStep),
})
